import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {word} from "../word.js";
import {Col, Row, Form} from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import {toast} from "react-toastify";
import Button from "../components/Button/Button.js";
import {REACT_APP_API_URL} from '../config.js';
import Api from "../Api.js";
import {useParams} from "react-router-dom";

const validationRules = {
    "user.first_name": (value) => value.length >= 3,
    "user.last_name": (value) => value.length >= 3,
    "phone": (value) => /^[0-9]/.test(value) && value.startsWith("0") && value.length === 9,
    "user.email": (value) => /^[\w.%+-]+@[\w-]+\.[\w]{2,}$/i.test(value),
    "user.password": (value) => value.length >= 6,
};

function AddManager({onHide,show, setData}) {
    const {type} = useParams();  // Get type from URL

    const [form, setForm] = useState([
        {key: "user.first_name", value: "", valid: false, errorMessage: "name_error", type: "text", label: ""},
        {key: "user.last_name", value: "", valid: false, errorMessage: "name_error", type: "text", label: ""},
        {key: "phone", value: "", valid: false, errorMessage: "phone_error", type: "text", label: ""},
        {key: "user.email", value: "", valid: false, errorMessage: "email_error", type: "email", label: ""},
        {key: "user.password", value: "", valid: false, errorMessage: "password_error", type: "password", label: ""},
    ]);

    const [imagePreviewUrl, setImagePreviewUrl] = useState("");
    const [image, setImage] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const success_notify = () => toast.success(word.success_process, { position: "top-center",theme: "colored", });
    const error_notify = () => toast.error(word.error_process, { position: "top-center",theme: "colored", });

    const handleKeyPress = async (e) => {
        if (e.key === "Enter") await addStuff();
    };

    const addStuff =async () => {
        try {
            let formData = new FormData();
            if (image) formData.append("image", image, image.name);
            setSubmitted(true);
            setDisabled(true);
            for (let field of form) {
                if (!field.valid) {
                    setDisabled(false);
                    return;
                }
                formData.append(field.key, field.value);
            }
            formData.append("accountant_type", `${REACT_APP_API_URL}accountant-types/${type}/`);
            const {data} = await Api.createAccount(formData)
            setData((prev) => ([...prev,data]))
            success_notify();
            onHide()
        }catch (e) {
            error_notify()
            console.log(e)
        }
    };


    const handleInputChange = (index, value) => {
        setForm((prevForm) => {
            const updatedForm = [...prevForm];
            const field = updatedForm[index];

            field.value = value;
            field.valid = validationRules[field.key] ? validationRules[field.key](value) : true;

            return updatedForm;
        });
    };

    const handleImageChange = (e) => {
        let file = e.target.files[0];
        if (file) {
            let reader = new FileReader();
            reader.onloadend = () => {
                setImagePreviewUrl(reader.result);
                setImage(file);
            };
            reader.readAsDataURL(file);
        }
    };
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{word.add_new_employee}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container">
                    <Row className="d-flex justify-content-around">
                        <Col xs={12} sm={10}>
                            <div className="add-img">
                                <label>
                                    <input type="file" onChange={handleImageChange}/>
                                    <span className="add-span">{word.add_picture}</span>
                                    <div className="add-round-img">
                                        {imagePreviewUrl ? (
                                            <div className="change-my-img"
                                                 style={{backgroundImage: `url(${imagePreviewUrl})`}}/>
                                        ) : (
                                            <i className="fas fa-camera"/>
                                        )}
                                    </div>
                                </label>
                                {form.map((item, index) => (
                                    <Form.Group className="justify-content-center form-group" key={index}>
                                        <Form.Control
                                            type={item.type}
                                            onKeyDown={handleKeyPress}
                                            className={!item.valid && submitted ? "form-control is-invalid" : "form-control"}
                                            autoComplete="off"
                                            placeholder={word[item.key]}
                                            value={item.value}
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                        />
                                        {!item.valid && submitted && (
                                            <div className="validation">
                                                <span>{word[item.errorMessage]}</span>
                                            </div>
                                        )}
                                    </Form.Group>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    {disabled && (
                        <div className="disable-loader">
                            <ClipLoader type="Oval" color="#101C2A" size={30} />
                        </div>
                    )}
                    <Row className="d-flex">
                        <Col xs={12} sm={10} className="d-flex align-items-end">
                            <Button
                                disabled={disabled}
                                buttonStyle={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
                                onChangeValue={addStuff}
                                title={word.confirmed}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddManager;